// mullion-v1-cast
export const getCastDetailInfoApi = "mullion-v1-cast-getCastDetailInfo";
export const setCastApi = "mullion-v1-cast-setCast";
export const setBankAccountApi = "mullion-v1-cast-setBankAccount";
export const getBankAccountApi = "mullion-v1-cast-getBankAccount";
export const getPaymentInfoApi = "mullion-v1-cast-getPaymentInfo";

// mullion-v1-guest
export const getGuestDetailInfoApi = "mullion-v1-guest-getGuestDetailInfo";
export const getGuestListApi = "mullion-v1-guest-getGuestList";
export const setGuestApi = "mullion-v1-guest-setGuest";
export const getGuestPaymentInfoApi = "mullion-v1-guest-getPaymentInfo";

// mullion-v1-users
export const getUserInfoApi = "mullion-v1-users-getUserInfo";

// mullion-v1-bosyu
export const getActiveBosyuListApi = "mullion-v1-bosyu-getActiveBosyuList";

